module.exports = __webpack_public_path__ + "static/media/expand.322a8df2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/expand.svg
// module id = 631
// module chunks = 0